import HeartIcon from "@Resources/images/iconsets/heart.svg?react";
import classNames from "classnames";

type TemperatureLabelProps = {
  temperature: number;
  feltTemperature?: number | null;
};

export const TemperatureLabel = ({
  temperature,
  feltTemperature,
}: TemperatureLabelProps) => {
  const hasFeelsLikeTemperature =
    feltTemperature !== null && feltTemperature !== undefined;
  return (
    <div className="m:flex m:h-full m:w-[46px] m:flex-col m:items-center">
      <span
        className="m:mt-1 m:leading-4 m:font-bold m:text-blue-950 m:dark:text-neutral-white"
        data-testid="hourly-navigation-temperature-item-temperature">{`${temperature}°`}</span>
      <span
        className={classNames(
          "m:mt-[2px] m:mb-1 m:flex m:min-h-[19px] m:w-12 m:items-center m:justify-center m:border-0 m:border-t m:border-solid m:border-transparent m:pt-[2px] m:leading-[15px] m:text-nowrap m:text-clip m:lg:min-w-[30px]",
          {
            "m:border-warmgrey-100 m:dark:border-blue-850":
              hasFeelsLikeTemperature,
          },
        )}>
        {hasFeelsLikeTemperature && (
          <>
            <HeartIcon className="m:text-warmgrey-700 m:dark:text-blue-400" />
            <span
              className="m:text-base m:font-normal m:tracking-0.4 m:text-warmgrey-700 m:antialiased m:dark:text-blue-400"
              data-testid="hourly-navigation-temperature-item-feels-like-temperature">{`${feltTemperature}°`}</span>
          </>
        )}
      </span>
    </div>
  );
};
